import { Button, Colors, Intent, TextArea } from "@blueprintjs/core";

import { Box, Flex } from "@/components/layout/flexbox";
import { LoadingOverlay } from "@/components/pieces/loading/LoadingOverlay";
import { BRAND_PURPLE, LIGHTEST_BACKGROUND } from "@/css/constants";

interface DesktopNoteEditableProps {
  value: string;
  loading: boolean;
  onSave: () => void;
  onCancel: () => void;
  onChange: (value: string) => void;
}

export function DesktopNoteEditable({
  value,
  loading,
  onSave,
  onCancel,
  onChange,
}: DesktopNoteEditableProps) {
  const allowSave = !!value.trim();
  return (
    <Box
      p={3}
      mb={3}
      mt={3}
      bg={LIGHTEST_BACKGROUND}
      style={{
        border: `1px solid ${Colors.LIGHT_GRAY3}`,
        borderRadius: "10px",
        position: "relative",
      }}
    >
      <TextArea
        fill={true}
        placeholder="New Notes"
        value={value}
        onChange={(e) => {
          onChange(e.target.value);
        }}
        intent={Intent.PRIMARY}
        autoResize={true}
        autoFocus={true}
      />
      <Flex justifyContent="flex-start" mt={3}>
        <Button
          disabled={!allowSave}
          intent={Intent.PRIMARY}
          onClick={onSave}
          style={{ backgroundColor: BRAND_PURPLE }}
          text="Save"
        />
        <Button
          style={{
            marginLeft: "8px",
            border: 0,
            boxShadow: "none",
            color: Colors.GRAY3,
            backgroundColor: Colors.LIGHT_GRAY5,
          }}
          onClick={onCancel}
        >
          Cancel
        </Button>
      </Flex>
      {loading && <LoadingOverlay />}
    </Box>
  );
}
